module.exports = __webpack_public_path__ + "static/media/facebook.4483ed04.svg";